import { useSelector } from 'react-redux'
import { userSelector } from '@src/selectors/app'

export const useUpsellOffer = () => {
  const user = useSelector(userSelector)
  if (!user || !('upsellOffer' in user)) {
    return undefined
  }

  return user.upsellOffer
}
